import { TripPayload } from 'store/trips/trips.types'

const getOrderKey = (task: TripPayload): string | undefined => {
  if (task.orderId) return task.orderId
  if (task.orderEventId) return `event:${task.orderEventId}`
  return undefined
}

export const getOrdersMissingDelivery = (
  tripTasks: TripPayload[]
): string[] => {
  const ordersWithDelivery = new Set<string>()
  const ordersWithDrop = new Set<string>()
  const eligibleOrderKeys: string[] = []

  for (const task of [...tripTasks].sort(
    (a, b) => a.sequenceId - b.sequenceId
  )) {
    const orderKey = getOrderKey(task)
    if (!orderKey) continue

    const isEligibleStart =
      task.type === 'PICKUP' ||
      (task.type === 'HOOK_TRAILER' &&
        (task.orderEventId != null || task.sourceOrderPkId != null))

    if (isEligibleStart && !eligibleOrderKeys.includes(orderKey)) {
      eligibleOrderKeys.push(orderKey)
    }
    if (task.type === 'DELIVERY') {
      ordersWithDelivery.add(orderKey)
    }
    if (task.type === 'DROP_TRAILER') {
      ordersWithDrop.add(orderKey)
    }
  }

  return eligibleOrderKeys.filter(
    (orderKey) =>
      !ordersWithDelivery.has(orderKey) && !ordersWithDrop.has(orderKey)
  )
}

export const getDeliveryTasksMissingPickup = (
  tripTasks: TripPayload[]
): TripPayload[] => {
  const ordersWithPickup = new Set<string>()
  const deliveries = new Map<string, TripPayload>()

  for (const task of [...tripTasks].sort(
    (a, b) => a.sequenceId - b.sequenceId
  )) {
    const orderKey = getOrderKey(task)
    if (!orderKey) continue

    const isPickup =
      task.type === 'PICKUP' ||
      (task.type === 'HOOK_TRAILER' &&
        (task.orderEventId != null || task.sourceOrderPkId != null))

    if (isPickup) {
      ordersWithPickup.add(orderKey)
    } else if (task.type === 'DELIVERY' && !deliveries.has(orderKey)) {
      deliveries.set(orderKey, task)
    }
  }

  return Array.from(deliveries.entries())
    .filter(([orderKey]) => !ordersWithPickup.has(orderKey))
    .map(([, task]) => task)
}
